import { API, getAPIInstance } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";

//-------------------------------------------
//           API Functions
//-------------------------------------------

const USER_BASE = "/Users";

const fetchCurrentUserAPI = async () =>
  (await getAPIInstance()).get(`${USER_BASE}/me`);
const getAccessRightsAPI = () => API.get(`${USER_BASE}/me/TeamAccess`);

//-------------------------------------------
//            Current User Service
//-------------------------------------------

const currentUserBaseService = createApplicationService({
  name: "currentUser",
  apiFetchFn: fetchCurrentUserAPI,
});

const currentUserReducer = currentUserBaseService.reducer;
const getCurrentUser = currentUserBaseService.getData;
const useCurrentUser = currentUserBaseService.useData;
const resetCurrentUser = currentUserBaseService.resetData;

const getAccessRightsData = getAccessRightsAPI;

export {
  currentUserReducer,
  getCurrentUser,
  useCurrentUser,
  getAccessRightsData,
  resetCurrentUser,
};
